export function formatCurrency(language: string, amount: number): string {
    return amount.toLocaleString(language, { currency: "USD", style: "currency" });
}

export function formatCurrencyNoSymbol(language: string, amount: number, fractionDigits?: number): string {
    return amount.toLocaleString(language, { maximumFractionDigits: fractionDigits ?? 2 });
}